import React, {useState} from "react";
import router, {Route} from "@/routing/Router";
import LoyaltyRewardHeading from "@widgets/loyaltyRewards/editor/heading/LoyaltyRewardHeading";
import SlimContainer from "@widgets/layout/SlimContainer";
import {useNavigate} from "react-router-dom";
import {FormProvider, useForm} from "react-hook-form";
import {LoyaltyRewardFormValues} from "@/data/entities/loyaltyReward";
import EditLoyaltyRewardCard from "@widgets/loyaltyRewards/editor/card/EditLoyaltyRewardCard";
import DeleteLoyaltyRewardModal from "@widgets/loyaltyRewards/delete/DeleteLoyaltyRewardModal";
import {SetLoyaltyRewardProps} from "@pages/authenticated/admin/loyaltyRewards/LoyaltyReward";

type Props = SetLoyaltyRewardProps & {
    restaurantId: number,
    route: Route,
    initialLoading: boolean,
};

const LoyaltyRewardEditor = ({route, initialLoading, loyaltyReward, setLoyaltyReward, restaurantId}: Props) => {
    const navigate = useNavigate();
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const formMethods = useForm<LoyaltyRewardFormValues>();

    return (
        <>
            <FormProvider {...formMethods}>
                <LoyaltyRewardHeading
                    route={route}
                    initialLoading={initialLoading}
                    loyaltyReward={loyaltyReward}
                    setLoyaltyReward={setLoyaltyReward}
                    setShowDeleteModal={setShowDeleteModal}
                />

                <SlimContainer
                    center={false}
                    className={"mt-6 md:mt-12"}
                >
                    <EditLoyaltyRewardCard
                        loyaltyReward={loyaltyReward}
                        setLoyaltyReward={setLoyaltyReward}
                        initialLoading={initialLoading}
                        restaurantId={restaurantId}
                    />
                </SlimContainer>
            </FormProvider>

            {
                loyaltyReward &&
                <DeleteLoyaltyRewardModal
                    show={showDeleteModal}
                    setShow={setShowDeleteModal}
                    loyaltyRewardId={loyaltyReward.id}
                    cb={() => navigate(router.loyaltyRewards.absolutePath())}
                />
            }
        </>
    );
};

export default LoyaltyRewardEditor;